import { useQuery } from "@tanstack/react-query";
import { api } from "api";

export const useFilterOptions = () => {
  const { data: examGroupOptions, isFetching: isExamGroupOptionsFetching } =
    useQuery({
      queryKey: ["examGroups"],
      queryFn: () => api.exams.getExams(),
      select: (response) =>
        response.data
          ?.map(({ id, name }) => ({
            value: id,
            label: name,
          }))
          .sort((a, b) => {
            const aIsPre = a.label.toLowerCase().startsWith("pre");
            const bIsPre = b.label.toLowerCase().startsWith("pre");
            if (aIsPre && !bIsPre) return -1;
            if (!aIsPre && bIsPre) return 1;
            return a.label.localeCompare(b.label, undefined, { numeric: true });
          }),
    });

  const { data: centreOptions, isFetching: isCentreOptionsFetching } = useQuery(
    {
      queryKey: ["centres"],
      queryFn: () => api.centres.getCentres(),
      select: (response) =>
        response.data?.map((centre) => ({
          value: centre.code,
          label: centre.city,
        })),
    }
  );

  return {
    examGroupOptions,
    centreOptions,
    isExamGroupOptionsFetching,
    isCentreOptionsFetching,
  };
};
